/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { InputText  } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';


import { rexgexEmail } from '@constants/general'

class ContactModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      nombre: '',
      telefono: '',
      correo: '',
      errors: []
    }
  }

  componentDidMount() {
    this.setState({
      nombre: this.props.nombre || '',
      telefono: this.props.telefono || '',
      correo: this.props.correo || '',
      loadingPage: false
    })
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { onContinueAction, onHidden } = this.props
    const { nombre, telefono, correo, justification } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
    onContinueAction({nombre, telefono, correo}, justification)
    return onHidden()
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t } = this.props
    const { nombre, correo, justification } = this.state
    let errors = {}
    if (!nombre) errors = { ...errors, 'nombre': `${t('Nombre')} ${t('es requerido')}`}
    if (!correo) errors = { ...errors, 'correo': `${t('Correo electrónico')} ${t('es requerido')}`}
    else if (!rexgexEmail.test(correo)) errors = { ...errors, 'correo': `${t('El formato de correo es inválido')}`}
    if (!justification) errors = { ...errors, 'justification': `${t('Justificación del cambio')} ${t('es requerido')}`}
    
    this.setState({errors})
    return errors
  }

  onChange = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  isFormFieldValid = (name) =>
    !!(this.state.errors[name]);

  getFormErrorMessage = (name) =>
    this.isFormFieldValid(name) && (
      <small className="p-error">{this.state.errors[name]}</small>
    );
  
  render () {
    const { t, display, title, onHidden, label, btnOkLabel, description } = this.props
    const { nombre, telefono, correo, loadingPage } = this.state

    const children = loadingPage ? '' : (
      <form className="p-mt-2 p-fluid" onSubmit={this.onSubmit}>
        <div className="p-col">
          <label className="">{description}</label>
        </div>
        <div className="col-12  p-field">
          <label className="p-text-bold p-pb-2">{label || t('Nombre')}</label>
          <InputText
            name="nombre"
            onChange={this.onChange}
            value={nombre}
            className={classNames({
              'p-invalid': this.isFormFieldValid(`nombre`),
            })}
          />
          {this.getFormErrorMessage(`nombre`)}
        </div>
        <div className="col-12  p-field">
          <label className="p-text-bold p-pb-2">{label || t('Télefono')}</label>
          <InputText
            name="telefono"
            onChange={this.onChange}
            value={telefono}
            className={classNames({
              'p-invalid': this.isFormFieldValid(`telefono`),
            })}
          />
          {this.getFormErrorMessage(`telefono`)}
        </div>
        <div className="col-12  p-field">
          <label className="p-text-bold p-pb-2">{label || t('Correo electrónico')}</label>
          <InputText
            name="correo"
            onChange={this.onChange}
            value={correo}
            className={classNames({
              'p-invalid': this.isFormFieldValid(`correo`),
            })}
          />
          {this.getFormErrorMessage(`correo`)}
        </div>
        <div className='p-col-12'>
          <label className="">{t('Justificación del cambio')}</label>
          <InputTextarea
            name="justification"
            onChange={(e) =>
              this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
            }
            rows={5}
            cols={30}
            className={classNames({
              'p-invalid': this.isFormFieldValid(`justification`),
            })}
          />
        {this.getFormErrorMessage(`justification`)}
        </div>
        <div className="p-dialog-footer custom">
          <div>
            <button className="p-button p-component p-button-secondary p-button-text p-button-raised" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">{t('Cerrar')}</span>
            </button> 
            <button className="p-button p-component" type="submit">
              <span className="p-button-label p-c">{btnOkLabel || 'Continuar'}</span>
            </button>
          </div>
        </div>
      </form>
    )
    if (loadingPage) return true;

    return (
      <Dialog
        header={title || t('Contacto')}
        visible={display}
        breakpoints={{'960px': '90vw'}}
        style={{ width: '60vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}



export default compose(
  withTranslation()(ContactModal))